export const typography = {
  h1: {
    fontWeight: 400,
    fontSize: 50,
    color: "#fff",
    "@media(max-width:767px)": {
      fontSize: "35px !important",
    },
  },
  h2: {
    fontWeight: 700,
    fontSize: 32,
    color: "#fff",
    wordBreak: "break-word",
    "@media(max-width:767px)": {
      fontSize: "30px !important",
    },
  },
  h3: {
    fontWeight: 600,
    fontSize: 32,
    color: "#fff",
    "@media(max-width:767px)": {
      fontSize: "20px !important",
    },
  },
  h4: {
    fontWeight: 500,
    fontSize: 28,
    color: "#fff",
    "@media(max-width:767px)": {
      fontSize: "18px !important",
    },
  },
  h5: {
    fontWeight: 400,
    fontSize: 22,
    color: "#fff",
    lineHeight: "35px",
    "@media(max-width:767px)": {
      fontSize: "17px !important",
    },
  },
  h6: {
    fontWeight: 500,
    fontSize: 18,
    color: "#fff",
    "@media(max-width:767px)": {
      fontSize: "13px !important",
    },
  },
  overline: {
    fontWeight: 500,
    fontFamily: "'Roboto', sans-serif",
  },
  button: {
    textTransform: "capitalize",
    borderRadius: 27,
  },
  body2: {
    fontSize: 16,
    fontWeight: 300,
    color: "#fff",

    lineHeight: "20px",
    "@media(max-width:767px)": {
      fontSize: "12px",
    },
  },
  body1: {
    fontWeight: 400,
    fontSize: 14,
    color: "#fff",
  },
  caption: {
    fontSize: 12,
    color: "#fff",
  },
};
